import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Component } from 'react';
import PropTypes from 'prop-types';
import identity from '../../fp/identity';
import shallowEqual from '../../utils/shallowEqual';
import Render from '../Render';

/**
 * @param {any} nextParams
 * @param {any} params
 * @returns {boolean}
 */
export function defaulShouldApply(nextParams, params) {
  return !shallowEqual(nextParams, params);
}

var Trigger = function (_Component) {
  _inherits(Trigger, _Component);

  function Trigger() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Trigger);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Trigger.__proto__ || _Object$getPrototypeOf(Trigger)).call.apply(_ref, [this].concat(args))), _this), _this.params = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Trigger, [{
    key: 'componentDidMount',

    /**
     * @public
     * @returns {void}
     */
    value: function componentDidMount() {
      var props = this.props;


      this.updateParams(props);
      this.applyAction();
    }

    /**
     * @public
     * @param {object} nextProps
     * @returns {void}
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var reapplyOnParamsChange = nextProps.reapplyOnParamsChange,
          shouldApply = nextProps.shouldApply;


      if (!reapplyOnParamsChange) {
        return;
      }

      var props = this.props,
          params = this.params;


      if (shallowEqual(nextProps, props)) {
        return;
      }

      var nextParams = this.updateParams(nextProps);

      if (!shouldApply(nextParams, params)) {
        return;
      }

      this.applyAction();
    }

    /**
     * @public
     * @var {any}
     */

  }, {
    key: 'updateParams',


    /**
     * @public
     * @param {object} props
     * @returns {any}
     */
    value: function updateParams(props) {
      var getParams = props.getParams;


      var params = getParams(props);
      this.params = params;

      return params;
    }

    /**
     * @public
     * @returns {void}
     */

  }, {
    key: 'applyAction',
    value: function applyAction() {
      var _props = this.props,
          actionName = _props.actionName,
          action = _props[actionName],
          params = this.params;


      if (action) {
        action(params);
      }
    }

    /**
     * @public
     * @returns {object}
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props;


      return Render(props);
    }
  }]);

  return Trigger;
}(Component);

Trigger.defaultProps = {
  reapplyOnParamsChange: true,
  shouldApply: defaulShouldApply,
  actionName: 'action',
  getParams: identity
};

if (process.env.NODE_ENV !== 'production') {
  Trigger.propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    render: PropTypes.func,
    reapplyOnParamsChange: PropTypes.bool,
    shouldApply: PropTypes.func,
    actionName: PropTypes.string,
    getParams: PropTypes.func,
    children: PropTypes.func
  };
}

export default Trigger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/components/Trigger/Trigger.js
// module id = 781
// module chunks = 0